module.exports = __webpack_public_path__ + "img/Startup Verband grau.7c4bcdcf.svg";